import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-xhr-backend';

import {
  translationEN,
  translationES,
} from './translations';

const resources = {
  es: {
    translation: translationES,
  },
  en: {
    translation: translationEN,
  },
};

const availableLanguages = Object.keys(resources);
const [defaultLanguage] = availableLanguages;
const fallbackLng = [defaultLanguage];

// Idioma fijo en español, sin detección por navegador: el panel está escrito en
// español (buena parte de los textos ni pasa por i18n) y no hay selector de
// idioma en ninguna pantalla. Con LanguageDetector, un Chrome en inglés
// resolvía 'en-US' → 'en' y dejaba los textos traducidos en inglés mezclados
// con el resto en español. El bundle en inglés se queda para cuando haya
// selector; mientras no exista, el idioma no lo decide el navegador.
i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    resources,
    lng: defaultLanguage,
    fallbackLng,

    debug: false,

    supportedLngs: availableLanguages,

    interpolation: {
      escapeValue: false,
    },
  });

function getCurrentLanguaje() {
  return localStorage
    .getItem('i18nextLng') || defaultLanguage;
}

function setMomentLocale() {
  try {
    require(`moment/locale/${getCurrentLanguaje()}`);
  } catch (error) {
    console.error(error);
  }
}

export {
  availableLanguages,
  defaultLanguage,
  getCurrentLanguaje,
  setMomentLocale,
};
